import { render, staticRenderFns } from "./PopTasks.vue?vue&type=template&id=71ee9da1&scoped=true&"
import script from "./PopTasks.vue?vue&type=script&lang=ts&"
export * from "./PopTasks.vue?vue&type=script&lang=ts&"
import style0 from "./PopTasks.vue?vue&type=style&index=0&id=71ee9da1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ee9da1",
  null
  
)

export default component.exports